import { Paperclip } from 'lucide-react';

import {
  formatDateWithoutSeconds,
  findNumberOfFiles,
  pluralize
} from '@/utils';
import { RichEditor } from '@/components/ui/richEditor';
import { FormBody } from '@/components/traceInspector/segmentDetail/formBody/formBody';
import { AvatarComponent } from '@/components/ui/avatar/avatar';
import { WidgetData } from '@/components/ui/widget/widget.type';

type Props = {
  data: WidgetData;
  traceInspector?: boolean;
  searchValue?: string;
};

export const AnswerCard = ({
  data,
  traceInspector = false,
  searchValue = ''
}: Props) => {
  const avatarSrc = data.createdBy?.avatar || data.link?.createdBy?.avatar;
  const name = data.createdBy?.name || data.link?.createdBy?.name;
  const group = data.group?.name || data.link?.group?.name;
  const date = data.createdAt || data.link?.createdAt;
  const answer = data.data?.answer || data.link?.answer;

  const numberOfFiles = findNumberOfFiles(data.data);

  return (
    data && (
      <div className="border-border text-card-foreground hover:border-primary-deep mt-4 ml-4 flex border-l-2 px-4">
        <AvatarComponent source={avatarSrc} name={name} size={20} />
        <div className="mx-3 w-full">
          <ul>
            {name && (
              <li className="flex flex-row flex-wrap items-center">
                <div className="mr-2.5 text-xs font-bold">{name}</div>
                {group && (
                  <div className="text-muted-foreground border-input border-l pl-2.5 text-[10px]">
                    {group}
                  </div>
                )}
              </li>
            )}
            <li>
              <p className="text-muted-foreground text-[10px]">
                on {formatDateWithoutSeconds(date.slice(0, 16))}
              </p>
            </li>
            {traceInspector ? (
              <FormBody
                linkCreatedByAccount={data?.linkCreatedByAccount}
                link={data?.link}
                traceId={data?.traceId}
                workflowContext={data?.workflowContext}
              />
            ) : (
              <>
                <li>
                  <div className="text-card-foreground mt-2">
                    <RichEditor
                      value={answer}
                      readOnly
                      searchValue={searchValue}
                    />
                  </div>
                </li>
                {!!numberOfFiles && (
                  <li className="text-muted-foreground relative pl-4 text-xs">
                    <Paperclip className="-l-2.5 absolute top-0.5 h-4" />
                    {`${pluralize(
                      numberOfFiles,
                      'Attachment'
                    )} (${numberOfFiles})`}
                  </li>
                )}
              </>
            )}
          </ul>
        </div>
      </div>
    )
  );
};
